module.exports = __webpack_public_path__ + "img/wordcloud-emils-pukis.87a56353.png";